import { SPAM_PROFILE_NAME_PATTERNS } from "./seo-policy";

const PROFILE_PATH_PATTERN = /^\/profile\/(.+)$/;

/**
 * @param {string} path Request path without query.
 * @return {boolean}
 */
export function isSpamProfilePath(path = "") {
  const match = path.match(PROFILE_PATH_PATTERN);
  if (!match) return false;

  const name = safeDecode(match[1]).replace(/^\d+-/, "");

  return SPAM_PROFILE_NAME_PATTERNS.some((pattern) => pattern.test(name));
}

function safeDecode(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}
